import { create } from "zustand";
import { useFetchHeadquarterWiseSalesSlice } from "../slices/HeadquarterWiseSalesSlice/fetchHeadquarterWiseSalesSlice";

interface HeadquarterWiseSalesInterface
  extends ReturnType<typeof useFetchHeadquarterWiseSalesSlice> {}

export const HeadquarterWiseSalesStore = create<HeadquarterWiseSalesInterface>(
  (...a) => ({
    ...useFetchHeadquarterWiseSalesSlice(...a),
  })
);
